<template>
  <div class="header">
    <div class="left">
      <img class="logo" fit="cover" src="/images/logo.png"/>
      <span style="line-height: 20px; font-size: 14px; font-weight: 700">Salework Chat</span>
    </div>
    <div class="right">
      <div id="status">
        <b-icon icon="search" v-if="globalData.logged_in_user.username.includes('sota/')" @click="openSearch()" class="pointer"></b-icon>
        <b-dropdown v-show="globalData.logged_in_user.type !== 'ADMIN'" variant="active" toggle-class="text-decoration-none" right no-caret  v-b-tooltip.hover.right="'Tùy chọn trạng thái'">
          <template #button-content >
            <div class="d-flex align-items-center ">
              <div :class="checkActive===true ? 'dot-active' : 'dot-busy'"></div>
              <div class="text-status"> {{ checkActive === true ? 'Hoạt động' : 'Bận' }}</div>
            </div>
          </template>
          <b-dropdown-item class="m-0" href="#" @click="setStatusActive">
            <div class="d-flex align-items-center">
              <div :class="'dot-active'"></div>
              <div class="text-status"> Hoạt động </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="m-0" href="#" @click="setStatusBusy">
            <div class="d-flex align-items-center">
              <div :class="'dot-busy'"></div>
              <div class="text-status"> Bận </div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <b-dropdown size="lg" variant="link" dropleft toggle-class="text-decoration-none" no-caret menu-class="popcus">
        <template #button-content>
          <i class="icon-icon-all-apps"></i>
        </template>
        <b-dropdown-item class="">
          <iframe id="app-salework-frame" src="https://salework.net/frame/app-salework"
                  style="width: 425px;  min-height: 445px; background-color: transparent; border-radius: 5px; border: none; "></iframe>
        </b-dropdown-item>
      </b-dropdown>
      <a href="https://salework.net/account" target="_blank" class="">
        <b-avatar class="user-profile" size="" :src="getUserAvatar()"></b-avatar>
      </a>
    </div>
  </div>
</template>

<script>
import api from "@/lib/callAPI"

export default {
  data() {
    return {
      setOnline: true,
    }
  },
  created() {
    this.socket.on('updateCompanyConfigurations', async data => {
      this.globalData.company_configurations = data.company_configurations
    });
  },
  computed:{
    checkActive(){
      return this.globalData.company_configurations.employees?.find(e => e.username === this.globalData.logged_in_user.username)?.status === 'active'
    },
  },
  methods: {
    getUserAvatar() {
      return "https://salework.net/storage/image/" + this.globalData.logged_in_user.avatar;
    },

    async setStatusActive() {
      this.setOnline = true;
      let req = {
        username: this.globalData.logged_in_user.username
      }
      await api.post( '/api/settings/setActive', req).then(result => {
        if (result.success) {
          this.globalData.company_configurations = result.data
        }else {
          // return this.$bvToast.toast(result.message, {variant: 'danger', solid: true, noCloseButton: true})
        }
      });
    },

    async setStatusBusy() {
      this.setOnline = false;
      let req = {
        username: this.globalData.logged_in_user.username
      }
      await api.post( '/api/settings/setBusy', req).then(result => {
        if (result.success) {
          this.globalData.company_configurations = result.data
        } else {
          // return this.$bvToast.toast(result.message, {variant: 'danger', solid: true, noCloseButton: true})
        }
      });
    },
    openSearch(){
      this.$router.push('/account-management');
    }
  },
}
</script>

<style>

.header {
  height: 48px;
  background-color: white;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DCDFE9;
}

.left {
  flex: 1;
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
}

.item {
  margin-right: 24px;
}

.logo {
  height: 32px;
  margin-left: 10px;
  margin-right: 4px;
}

.icon {
  font-size: 24px;
}

.user-profile {
  height: 28px;
  width: 28px;
  margin-right: 12px;
}



.popcus {
  width: 470px;
}

.dropdown-item:hover {
  background-color: #ffffff !important;
}

.dot-active {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #4B9E77;
  margin-top: 1px;
}

.dot-busy {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #CF4547;
  margin-top: 1px;
}

.text-status {
  font-size: 14px;
  line-height: 24px;
  margin-left: 8px;
}

#status .dropdown-menu {
  padding: 0px !important;
  min-width: 110px !important;
}

#status .dropdown-item:hover {
  background-color: #F4F5F9 !important;
}

</style>
